import { createApp } from 'vue'

import App from './App.vue'
import { router } from '@web/router'
import { store } from './store'

import { Vue3Mq } from 'vue3-mq'

import i18n from './plugins/i18n'
import './common/tingle'

import smoothScroll from 'smoothscroll-polyfill'

import '@web/common/consoleDebug'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import sentry, { init as sentryInit } from '@web/common/sentry'
import locale from '@web/common/locale'
import Logger from '@web/common/Logger'
import { fetchConfig, getState } from '@web/common/ExternalConfig/ExternalConfig'
import { appsflyerSmartBanner } from '@web/common/ExternalConfig/getters'
import '@web/common/Validator.ts'
import * as AnalyticEvents from '@web/services/Analytics/events'
import Analytics from '@web/services/Analytics/Analytics'

import 'maz-ui/css/main.css'

import '@ui-kit/styles/main.scss'

smoothScroll.polyfill()

store.dispatch('assets/fetchConfig')
  .then(fetchConfig).then(() => {
    const gtmId = getState()?.data?.gtm
    Analytics.init({
      gtmId
    })
  })
  .then(() => {
    locale.init({
      supportedLanguage: store.state.assets.supportedLanguage,
      defaultLanguage: store.state.assets.defaultLanguage
    })

    const app = createApp(App)
    sentryInit(app, router)

    app
      .use(router)
      .use(store)
      .use(Vue3Mq, {
        breakpoints: { // default breakpoints - customize this
          mobile: 0,
          tablet: 414 * 2,
          // область контента + место под стрелку * 2 + место между стрелкой и контентом * 2
          desktop: 1192 + 12 * 2 + 14 * 2
        }
      })
      .use(i18n)
      .mount('#app')

    const _appsflyerSmartBanner = appsflyerSmartBanner()
    if (_appsflyerSmartBanner.script) {
      const script = document.createElement('script')
      script.innerHTML = _appsflyerSmartBanner.script
      document.head.appendChild(script)
    } else if (_appsflyerSmartBanner.key) {
      const script = document.createElement('script')
      script.innerHTML = `!function (t, e, n, s, a, c, i, o, p) { t.AppsFlyerSdkObject = a, t.AF = t.AF || function () { (t.AF.q = t.AF.q || []).push([Date.now()].concat(Array.prototype.slice.call(arguments))) }, t.AF.id = t.AF.id || i, t.AF.plugins = {}, o = e.createElement(n), p = e.getElementsByTagName(n)[0], o.async = 1, o.src = "https://websdk.appsflyer.com?" + (c.length > 0 ? "st=" + c.split(",").sort().join(",") + "&" : "") + (i.length > 0 ? "af_id=" + i : ""), p.parentNode.insertBefore(o, p) }(window, document, "script", 0, "AF", "banners", { banners: { key: "${_appsflyerSmartBanner.key + '123'}" } }); AF('banners', 'showBanner');`
      document.head.appendChild(script)
    }
  })
  .catch(e => {
    Logger.error(e)
    sentry.captureException(e)
    Swal.fire({
      icon: 'error',
      title: i18n.global.t('error.error'),
      text: i18n.global.t('error.errorLoadConfig')
    })
  })
